import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import minifyTheme from 'minify-css-string'

//Idiomas
import es from 'vuetify/es5/locale/es'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      options: { minifyTheme },
      light: {
        primary: '#004259',
        secondary: '#00b4b8',
        accent: '#00eed7',
        error: '#f7104a',
        warning: '#ff9800',
        info: '#01bbf1',
        success: '#4caf50',
        blueContpaqi: '#0026a4'
      }
    }
  },
  icons: {
    iconfont: 'mdiSvg',
  },
  lang: {
    locales: { es },
    current: 'es'
  }
})
